<template>
    <main class="course-img">
        <div :infinite-scroll-disabled="true">
          <img v-for="(item,index) in imgUrls" :key="index" v-lazy="youpPath+item" alt='教程'/>
        </div>
    </main>
</template>

<script>
import { IMG_BASE_URL } from '@/config'
export default {
  name: 'CourseImgsTemp',
  data () {
    return {
      youpPath: IMG_BASE_URL
    }
  },
  props: {
    imgUrls: {
      type: Array,
      required: true,
      default () {
        return []
      }
    }
  }
}
</script>

<style scoped="scoped">
  .course-img,.course-img img{
    width:100%;
  }
</style>
